import { CurrencySchema, TrialDurationSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const CreateInvoiceSettingsSchema = oz.object({
  customerId: oz.string({
    ['required_error']: 'Customer is required',
  }),
  currency: CurrencySchema,
  startPeriod: oz.string(),
  paymentDueDays: oz.number(),
  trialPeriod: TrialDurationSchema,
  purchaseOrder: oz.string().optional(),
}).openapi('CreateInvoiceSettings');

export type CreateInvoiceSettings = oz.infer<typeof CreateInvoiceSettingsSchema>;